<div class="container p-2">
  <div class="row">
    <div class="col-12">
      <app-title-with-back name="Fiduciaria" [showButton]="currentStep !== FiduciaryStep.Form" (backClicked)="backStep()">
        Consulta Solicitudes Fiduciaria
      </app-title-with-back>
    </div>
  </div>

  <section class="row">
    <div class="col-md-6 mx-auto" [hidden]="currentStep !== FiduciaryStep.Form">
      <app-fiduciary-search-form (submitForm)="onSubmitSearchForm($event)"></app-fiduciary-search-form>
    </div>

    <div class="col-12" *ngIf="currentStep === FiduciaryStep.Result">
      <app-fiduciary-requests-table
        (seeDetails)="onSeeDetails($event)"
        [requests]="trustRequests$ | async"
        [loading]="trustRequests$ | loading | async"
      ></app-fiduciary-requests-table>
    </div>

    <div class="col-lg-8 col-md-12 mx-auto fiduciary-step-details" *ngIf="currentStep === FiduciaryStep.Details">
      <app-request-details 
        [request]="selectedRequest" 
        [requestFilter]="currentRequestFilter" 
        (refreshRequestResult)="sendSearchForm($event)"
      ></app-request-details>
    </div>
  </section>
</div>
